import moment from "moment";

export async function wait(ms) {
  return new Promise((resolve) => setTimeout(() => resolve(), ms));
};

export async function getResultsInParallel(arr, fn) {
  let promisesArr = arr.map((item) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res;
        if (Array.isArray(item)) {
          res = await fn(...item);
        } else {
          res = await fn(item);
        }
        resolve(res);
        return res;
      } catch(ex) {
        console.error(ex);
        reject(ex);
      }
    });
  });
  let promiseResults = await Promise.allSettled(promisesArr);
  return promiseResults;
}

export function convertToArray(refs) {
  let regArr = [];
  refs.forEach((r) => {
    let rD = r.data();
    rD.id = r.id;
    regArr.push(rD);
  });
  return regArr;
}

export function processToTimestamp(dateObject) {
  let ret = dateObject ? moment(dateObject) : null;
  return ret ? ret.format("MMM Do YYYY") : "-";
}

export function arrayUnion(arrA, arrB, fn) {
  arrA = arrA || [];
  arrB = arrB || [];
  let ret = [...new Set([...arrA, ...arrB])].filter((i) => !!i);
  return ret;
}

// ref: https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export function getHash(inp, mod = 1) {
  inp = inp || "";
  let hash = 28213, i, chr;
  for (i = 0; i < inp.length; i++) {
    chr = inp.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash % mod);
}

export function randomNumber(min, max) {
  return Math.abs(Math.round(Math.random() * (max - min) + min));
}

export function getRandomItems(arr, num = 1, changeEverytime = false) {
  let sortFn = (a, b) => a < b ? -1 : 1;
  if (changeEverytime) {
    sortFn = () => 0.5 - Math.random();
  }
  let shuffled = [...arr].sort(sortFn);
  return shuffled.slice(0, num);
}

// ref: https://stackoverflow.com/questions/64811378/javascript-object-spread-with-an-object-that-may-have-undefined-objects-as-data
export function cleanUndefined(obj) {
  return new Proxy(obj, {
    ownKeys() {
      return Object.keys(obj).filter(key => obj[key] !== undefined)
    }
  })
}

// TODO: NEEDS TESTING
export function mergeObjsRightOverwrites() {
  let objsArr = [].slice.apply(arguments);
  // let retVal = Object.assign({});
  let retVal = {};
  for (let o of objsArr) {
    retVal = { ...cleanUndefined(o), ...cleanUndefined(retVal) };
  }
  return retVal;
}
